/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.service.ts"/>
///<reference path="../../../../components/busy/busy.interface.ts"/>
///<reference path="../../docs-and-forms-api.service.ts"/>
///<reference path="../../../../components/modal/modal.enums.ts"/>

module Meevo.Plugins.DocsAndForms {

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;


    class DocsAndFormsCustomFormFieldsComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            '$timeout',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
        ];

        public formBuilderModel: IFormBuilderModel;
        public docsAndFormsModel: IDocsAndFormsModel;
        public disabled: boolean;

        get tabTypeEnum() {
            return FormTypeEnum;
        }

        constructor(private $scope: ng.IScope,
                    private $timeout: ng.ITimeoutService,
                    private docsAndFormsApiService: DocsAndFormsApiService,
                    private modalService: Meevo.Components.Modal.IModalService,
                    private busyService: Meevo.Components.Busy.IBusyService,
                    private docsAndFormsService: DocsAndFormsService) {
        }

        $onInit() {
            this.docsAndFormsApiService
                .getAssignedUDFs(this.docsAndFormsModel.id, this.docsAndFormsModel.tabTypeEnum)
                .then((data: IUserDefinedControl[]) => {
                        this.formBuilderModel.assignedUDFs = this.docsAndFormsService.populateAssignedUdfs(data, this.docsAndFormsModel);
                });
        }

		addUdf() {
			this.docsAndFormsService
				.showAddCustomFormFieldModal(this.docsAndFormsModel)
				.then((data: IUserDefinedControl) => {
					this.formBuilderModel.assignedUDFs.push(
						new DocsAndFormAssignedUDFItem(<IDocsAndFormAssignedCFF>{
							...data,
							selected: true
						})
					);
				});
		}

		editUdfs(userDefinedControl: IUserDefinedControl) {
			this.docsAndFormsService
				.showEditCustomFormFieldModel(this.docsAndFormsModel, userDefinedControl)
				.then((data: IUserDefinedControl) => {
					this.$timeout(() => {
						_.extend(userDefinedControl, data);
						this.formBuilderModel.assignedUDFs = angular.copy(this.formBuilderModel.assignedUDFs);
					}, 100);
				});
		}

		removeUdfs(userDefinedControl: IUserDefinedControl) {
			this.docsAndFormsService
				.removeCustomFormField(userDefinedControl)
				.then(() => {
					this.formBuilderModel.assignedUDFs = this.formBuilderModel
						.assignedUDFs.filter((udf) => udf.control_TId !== userDefinedControl.control_TId);
				})
		}

    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsCustomFormFieldsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/custom-form-fields/docs-and-forms-custom-form-fields.component.html',
            controller: DocsAndFormsCustomFormFieldsComponent,
            controllerAs: '$ctrl',
            bindings: {
                formBuilderModel: '=',
                docsAndFormsModel: '=',
                disabled: '=?ngDisabled',
            }
        });

}
